import { actions } from "./action-list";

export function citiesFetched(value) {
  return {
    type: actions.FETCH_CITIES,
    value,
  };
}

export function selectedCity(value) {
  return {
    type: actions.SELECTED_CITY,
    value,
  };
}
